<template>
  <div class="order">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="全部" name="0">
                <div class="search">
                    <el-date-picker
                    style="margin-right:1%"
                    v-model="startTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    placeholder="起保日期">
                    </el-date-picker>
                <span class="demonstration" style="line-height: 38px;font-size: 14px;">至</span>
                    <el-date-picker
                    style="margin-left:1%"
                    v-model="endTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    placeholder="起保日期">
                    </el-date-picker>
                    <el-input v-model="ordernum" placeholder="订单号"></el-input>
                    <el-input v-model="username" placeholder="客户姓名"></el-input>
                    <el-input v-model="carnum" placeholder="车架号"></el-input>
                    <el-input v-model="company" placeholder="金融公司"></el-input>
                    <el-select v-model="areavalue" placeholder="订单类别" @change="areaselect">
                        <el-option
                        v-for="item in areaoptions"
                        :key="item.value"
                        :label="item.lable"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    <el-button  v-preventReClick type="primary" @click="search()">查询</el-button>
                </div>
                <div class="tablelist">
                    <el-table
                        :data="tableData"
                        :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                        style="width: 100%">
                        <el-table-column
                            prop="code"
                            label="订单号"
                            width="120">
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            width="90"
                            label="车主姓名">
                        </el-table-column>
                        <el-table-column
                            prop="phone"
                            width="100"
                            label="手机号">
                        </el-table-column>
                        <el-table-column
                            prop="carModelOne"
                            width="100"
                            label="汽车车型">
                            <template slot-scope="scope">
                                {{scope.row.carModelOne + scope.row.carModelTwo}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="vin"
                            width="100"
                            label="车架号">
                        </el-table-column>
                        <el-table-column
                            width="150"
                            prop="productName"
                            label="产品名称">
                        </el-table-column>
                        <el-table-column
                            prop="saleType"
                            width="100"
                            label="订单类型">
                            <template slot-scope="scope">
                                {{scope.row.saleType == 1?'销售':scope.row.saleType == 2?'续费':'销售'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="clearingFormType"
                            width="100"
                            label="支付方式">
                            <template slot-scope="scope">
                                {{scope.row.clearingFormType == 1 ? '月结': scope.row.clearingFormType == 2?'预付款':'扫码付款'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="revokeState"
                            width="100"
                            label="作废状态">
                            <template slot-scope="scope">
                                {{scope.row.revokeState == 0?'未作废':scope.row.revokeState == 1?'待审核':scope.row.revokeState == 2?'已作废':'未通过'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="180"
                            prop="paymentDate"
                            label="销售日期">
                        </el-table-column>
                        <el-table-column
                            width="180"
                            prop="revokeSubmitTime"
                            label="提交审核日期">
                        </el-table-column>
                        <el-table-column
                            prop=""
                             width="180"
                            label="操作">
                            <template slot-scope="scope">
                                <el-link :underline="false" @click="look(scope.row)">查看</el-link>
                                <el-link v-if="scope.row.revokeState == 3" :underline="false" @click="submit(scope.row)">重新提交</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="待审核" name="1">
                <div class="search">
                    <el-date-picker
                    style="margin-right:1%"
                    v-model="startTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    placeholder="起保日期">
                    </el-date-picker>
                <span class="demonstration" style="line-height: 38px;font-size: 14px;">至</span>
                    <el-date-picker
                    style="margin-left:1%"
                    v-model="endTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    placeholder="起保日期">
                    </el-date-picker>
                    <el-input v-model="ordernum" placeholder="订单号"></el-input>
                    <el-input v-model="username" placeholder="客户姓名"></el-input>
                    <el-input v-model="carnum" placeholder="车架号"></el-input>
                    <el-input v-model="company" placeholder="金融公司"></el-input>
                    <el-select v-model="areavalue" placeholder="订单类别" @change="areaselect">
                        <el-option
                        v-for="item in areaoptions"
                        :key="item.value"
                        :label="item.lable"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    <el-button  v-preventReClick type="primary" @click="search()">查询</el-button>
                </div>
                <div class="tablelist">
                    <el-table
                        :data="tableData1"
                        :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                        style="width: 100%">
                        <el-table-column
                            prop="code"
                            label="订单号"
                            width="120">
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            width="90"
                            label="车主姓名">
                        </el-table-column>
                        <el-table-column
                            prop="phone"
                            width="100"
                            label="手机号">
                        </el-table-column>
                        <el-table-column
                            prop="carModelOne"
                            width="100"
                            label="汽车车型">
                            <template slot-scope="scope">
                                {{scope.row.carModelOne + scope.row.carModelTwo}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="vin"
                            width="100"
                            label="车架号">
                        </el-table-column>
                        <el-table-column
                            width="150"
                            prop="productName"
                            label="产品名称">
                        </el-table-column>
                        <el-table-column
                            prop="saleType"
                            width="100"
                            label="订单类型">
                            <template slot-scope="scope">
                                {{scope.row.saleType == 1?'销售':scope.row.saleType == 2?'续费':'销售'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="clearingFormType"
                            width="100"
                            label="支付方式">
                            <template slot-scope="scope">
                                {{scope.row.clearingFormType == 1 ? '月结': scope.row.clearingFormType == 2?'预付款':'扫码付款'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="revokeState"
                            width="100"
                            label="作废状态">
                            <template slot-scope="scope">
                                {{scope.row.revokeState == 0?'未作废':scope.row.revokeState == 1?'待审核':scope.row.revokeState == 2?'已作废':'未通过'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="180"
                            prop="paymentDate"
                            label="销售日期">
                        </el-table-column>
                        <el-table-column
                            width="180"
                            prop="revokeSubmitTime"
                            label="提交审核日期">
                        </el-table-column>
                        <el-table-column
                            prop=""
                            width="180"
                            label="操作">
                            <template slot-scope="scope">
                                <el-link :underline="false" @click="look(scope.row)">查看</el-link>
                                <el-link v-if="scope.row.revokeState == 3" :underline="false" @click="submit(scope.row)">重新提交</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="审核未通过" name="3">
                <div class="search">
                    <el-date-picker
                    style="margin-right:1%"
                    v-model="startTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    placeholder="起保日期">
                    </el-date-picker>
                <span class="demonstration" style="line-height: 38px;font-size: 14px;">至</span>
                    <el-date-picker
                    style="margin-left:1%"
                    v-model="endTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    placeholder="起保日期">
                    </el-date-picker>
                    <el-input v-model="ordernum" placeholder="订单号"></el-input>
                    <el-input v-model="username" placeholder="客户姓名"></el-input>
                    <el-input v-model="carnum" placeholder="车架号"></el-input>
                    <el-input v-model="company" placeholder="金融公司"></el-input>
                    <el-select v-model="areavalue" placeholder="订单类别" @change="areaselect">
                        <el-option
                        v-for="item in areaoptions"
                        :key="item.value"
                        :label="item.lable"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    <el-button  v-preventReClick type="primary" @click="search()">查询</el-button>
                </div>
                <div class="tablelist">
                    <el-table
                        :data="tableData2"
                        :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                        style="width: 100%">
                        <el-table-column
                            prop="code"
                            label="订单号"
                            width="120">
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            width="90"
                            label="车主姓名">
                        </el-table-column>
                        <el-table-column
                            prop="phone"
                            width="100"
                            label="手机号">
                        </el-table-column>
                        <el-table-column
                            prop="carModelOne"
                            width="100"
                            label="汽车车型">
                            <template slot-scope="scope">
                                {{scope.row.carModelOne + scope.row.carModelTwo}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="vin"
                            width="100"
                            label="车架号">
                        </el-table-column>
                        <el-table-column
                            width="150"
                            prop="productName"
                            label="产品名称">
                        </el-table-column>
                        <el-table-column
                            prop="saleType"
                            width="100"
                            label="订单类型">
                            <template slot-scope="scope">
                                {{scope.row.saleType == 1?'销售':scope.row.saleType == 2?'续费':'销售'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="clearingFormType"
                            width="100"
                            label="支付方式">
                            <template slot-scope="scope">
                                {{scope.row.clearingFormType == 1 ? '月结': scope.row.clearingFormType == 2?'预付款':'扫码付款'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="revokeState"
                            width="100"
                            label="作废状态">
                            <template slot-scope="scope">
                                {{scope.row.revokeState == 0?'未作废':scope.row.revokeState == 1?'待审核':scope.row.revokeState == 2?'已作废':'未通过'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="180"
                            prop="paymentDate"
                            label="销售日期">
                        </el-table-column>
                        <el-table-column
                            width="180"
                            prop="revokeSubmitTime"
                            label="提交审核日期">
                        </el-table-column>
                        <el-table-column
                            prop=""
                            width="180"
                            label="操作">
                            <template slot-scope="scope">
                                <el-link :underline="false" @click="look(scope.row)">查看</el-link>
                               <el-link v-if="scope.row.revokeState == 3" :underline="false" @click="submit(scope.row)">重新提交</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="已作废" name="2">
               <div class="search">
                    <el-date-picker
                    style="margin-right:1%"
                    v-model="startTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    placeholder="起保日期">
                    </el-date-picker>
                <span class="demonstration" style="line-height: 38px;font-size: 14px;">至</span>
                    <el-date-picker
                    style="margin-left:1%"
                    v-model="endTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    placeholder="起保日期">
                    </el-date-picker>
                    <el-input v-model="ordernum" placeholder="订单号"></el-input>
                    <el-input v-model="username" placeholder="客户姓名"></el-input>
                    <el-input v-model="carnum" placeholder="车架号"></el-input>
                    <el-input v-model="company" placeholder="金融公司"></el-input>
                    <el-select v-model="areavalue" placeholder="订单类别" @change="areaselect">
                        <el-option
                        v-for="item in areaoptions"
                        :key="item.value"
                        :label="item.lable"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    <el-button  v-preventReClick type="primary" @click="search()">查询</el-button>
                </div>
                <div class="tablelist">
                    <el-table
                        :data="tableData3"
                        :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                        style="width: 100%">
                        <el-table-column
                            prop="code"
                            label="订单号"
                            width="120">
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            width="90"
                            label="车主姓名">
                        </el-table-column>
                        <el-table-column
                            prop="phone"
                            width="100"
                            label="手机号">
                        </el-table-column>
                        <el-table-column
                            prop="carModelOne"
                            width="100"
                            label="汽车车型">
                            <template slot-scope="scope">
                                {{scope.row.carModelOne + scope.row.carModelTwo}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="vin"
                            width="100"
                            label="车架号">
                        </el-table-column>
                        <el-table-column
                            width="150"
                            prop="productName"
                            label="产品名称">
                        </el-table-column>
                        <el-table-column
                            prop="saleType"
                            width="100"
                            label="订单类型">
                            <template slot-scope="scope">
                                {{scope.row.saleType == 1?'销售':scope.row.saleType == 2?'续费':'销售'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="clearingFormType"
                            width="100"
                            label="支付方式">
                            <template slot-scope="scope">
                                {{scope.row.clearingFormType == 1 ? '月结': scope.row.clearingFormType == 2?'预付款':'扫码付款'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="revokeState"
                            width="100"
                            label="作废状态">
                            <template slot-scope="scope">
                                {{scope.row.revokeState == 0?'未作废':scope.row.revokeState == 1?'待审核':scope.row.revokeState == 2?'已作废':'未通过'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="180"
                            prop="paymentDate"
                            label="销售日期">
                        </el-table-column>
                        <el-table-column
                            width="180"
                            prop="revokeSubmitTime"
                            label="提交审核日期">
                        </el-table-column>
                        <el-table-column
                            prop=""
                            width="180"
                            label="操作">
                            <template slot-scope="scope">
                                <el-link :underline="false" @click="look(scope.row)">查看</el-link>
                                <el-link v-if="scope.row.revokeState == 3" :underline="false" @click="submit(scope.row)">重新提交</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <div class="page">
                    <el-pagination
                        :background="true"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="page"
                        :page-sizes="[10]"
                        :page-size="10"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                    </el-pagination>
            </div>
      </el-tabs>
      <!-- 重新提交 -->
      <el-dialog
        title="重新提交"
        :visible.sync="dialogVisibleviod"
        width="30%"
        >
       <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="作废理由" prop="desc">
                <el-input type="textarea" v-model="ruleForm.desc"></el-input>
            </el-form-item>
       </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button  v-preventReClick @click="dialogVisibleviod = false">取 消</el-button>
            <el-button  v-preventReClick type="primary" @click="submitForm()">确 定</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
// import {selectAllOrderAdmin,searchConditionAdmin} from '../axios/api'
import {getselllist,afreshSubmit} from '../axios/api'
export default {
    data(){
        return{
            activeName: '0',
            shopname:'',
            ordernum:'',
            username:'',
            carnum:'',
            company:'',
            areavalue:'',
            areaoptions: [{
                value: '销售',
                label: '销售'
                }, {
                value: '续费',
                label: '续费'
            }],
            tableData:[],
            tableData1:[],
            tableData2:[],
            tableData3:[],
            total:0,
            page:1,
            currentPage4:1,
            tabid:0,
            allvalue:'',
            dialogVisibleviod:false,
            ruleForm: {
                desc: ''
            },
            rules: {
                desc: [
                    { required: true, message: '请填写作废理由', trigger: 'blur' }
                ]
            },
            startTime:'',
            endTime:'',
            submitid:'',
            states:0,
            revokeAuditUser:''
        }
    },
    created(){
        this.getdata()
    },
    methods:{
        handleClick(tab, event) {
            this.ordernum = ''
            this.startTime = ''
            this.endTime = ''
            this.carnum = ''
            this.company = ''
            this.username = ''
            this.areavalue = ''
            console.log(tab, event);
            this.tabid = tab.name
            this.getdata()
        },
        look(row){
            this.$router.push({
                name:'作废详情',
                params:{
                    id:row.code,
                    ids:row.id
                }
            })
        },
        submitForm(){ 
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    var {data:dt} = await afreshSubmit({
                    id:this.submitid,
                    revokeApplyReason:this.ruleForm.desc,
                    revokeAuditUser:this.revokeAuditUser,
                    isResubmit:'2'
                })
                    console.log(dt)
                    if(dt.code == 200){
                        this.$message.success(dt.message)
                        this.dialogVisibleviod = false
                        this.getdata()
                    }else{
                        this.$message.error(dt.message)
                    }
                }
            });
        },
        submit(row){
            console.log(row)
            this.submitid = row.id
            this.ruleForm.desc = row.revokeApplyReason
            this.dialogVisibleviod = true
            this.revokeAuditUser = row.revokeAuditUser
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.page = val
            if(this.states == 0){
                this.getdata()
            }else{
                this.search1()
            }
            
        },
        async getdata(){
            this.states = 0
            var {data:dt} = await getselllist({
                current:this.page,
                limit:10,
                revokeState:this.tabid,
                 shopId:window.localStorage.getItem('shopId')
            })
            console.log(dt)
            if(dt.code == 200){
                this.total = dt.data.page.total
                if(this.tabid == 0){
                    this.tableData = dt.data.page.records
                }else if(this.tabid == 1){
                    this.tableData1 = dt.data.page.records
                }else if(this.tabid == 3){
                    this.tableData2 = dt.data.page.records
                }else if(this.tabid == 2){
                    this.tableData3 = dt.data.page.records
                }
                
            }
        },
        async search(){
            this.states = 1
            var {data:dt} = await getselllist({
                current:1,
                limit:10,
                revokeState:this.tabid,
                startEffectiveDate:this.startTime,
                endEffectiveDate:this.endTime,
                code:this.ordernum,
                name:this.username,
                vin:this.carnum,
                financialCompany:this.compay,
                saleType:this.areavalue == '销售'?1 :this.areavalue == '续费'?2 :'',
                 shopId:window.localStorage.getItem('shopId')
            })
            console.log(dt)
            if(dt.code == 200){
                this.page = 1
                this.total = dt.data.page.total
                if(this.tabid == 0){
                    this.tableData = dt.data.page.records
                }else if(this.tabid == 1){
                    this.tableData1 = dt.data.page.records
                }else if(this.tabid == 3){
                    this.tableData2 = dt.data.page.records
                }else if(this.tabid == 2){
                    this.tableData3 = dt.data.page.records
                }
                
            }
        },
        async search1(){
            this.states = 1
            var {data:dt} = await getselllist({
                current:this.page,
                limit:10,
                revokeState:this.tabid,
                startEffectiveDate:this.startTime,
                endEffectiveDate:this.endTime,
                code:this.ordernum,
                name:this.username,
                vin:this.carnum,
                financialCompany:this.compay,
                saleType:this.areavalue == '销售'?1 :this.areavalue == '续费'?2 :'',
                shopId:window.localStorage.getItem('shopId')
            })
            console.log(dt)
            if(dt.code == 200){
                this.total = dt.data.page.total
                if(this.tabid == 0){
                    this.tableData = dt.data.page.records
                }else if(this.tabid == 1){
                    this.tableData1 = dt.data.page.records
                }else if(this.tabid == 3){
                    this.tableData2 = dt.data.page.records
                }else if(this.tabid == 2){
                    this.tableData3 = dt.data.page.records
                }
                
            }
        },
        areaselect(value){
            console.log(value)
            this.areavalue = value
            // if(value == '销售'){
            //     this.areavalue = 1
            // }else{
            //     this.areavalue = 2
            // }
            
        },
    }
}

</script>
<style lang="less" scoped>
.order{
    background: #fff;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
    .tablelist{
        margin-top: 15px;
        .el-link .el-link--default {
            color: #409eff;
            margin-right: 12px;
        }
    }
}
</style>
<style>
.el-link.el-link--default{
     color: #409eff;
    margin-right: 12px;
}
</style>